import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _get from "lodash/get";
import _capitalize from "lodash/capitalize";
import SRLStackedTooltip from "../SRLStackedTooltip/SRLStackedTooltip";


const SRLFrequencyCustomTooltip = ({ active, activePayload }) => {
  const offsetX = _get(activePayload, 'offsetX');
  return (
    <SRLStackedTooltip
      active={active}
      payload={activePayload}
      triangleOffset={offsetX}
    >
      {(payload) => {
        const value = _get(payload, 'value', '');
        const key = _get(payload, 'key', '');
        const answer = _get(payload, 'answer', '');
        return (
          <Fragment>
            <b>{value}</b>
            <span>{` student${value !== 1 ? 's' : ''} chose `}</span>
            <b>{_capitalize(key)}</b>
            <span> in the response to </span>
            <b>{answer}</b>
          </Fragment>
        );
      }}
    </SRLStackedTooltip>
  );
};

SRLFrequencyCustomTooltip.propTypes = {
  active: PropTypes.bool,
  activePayload: PropTypes.object,
};

export default SRLFrequencyCustomTooltip;
